export default __webpack_public_path__ + "static/media/Matter-Bold.6f2769f1.eot";